/* ==========================================================================
   4WD / Truck switch in the vehicle band (Option A, approved by Ash 3 Nov 2026)
   Truck makes are the T_ keys in assets/search-by-vehicle-data.js, for example
   "T_Hino": [{ "300 Series": { "2020": "/collections/..." } }]
   The T_ stays in the option value and in localStorage, so scripts.js can look
   the make up. Customers only ever see it without the T_.
   No T_ makes in the file: nothing changes and "Search by 4WD" stays as it is.
   Which search shows first: a saved vehicle, then ?vehicle=truck or ?vehicle=4wd,
   then the customer's last choice, then trucksuspensions.com.au = Truck, else 4WD.
   A truck model with only one option ("All Years") skips step 3 and opens its collection.
   ========================================================================== */
(function () {
  if (window.dsVehicleSwitch) return;
  var PRE = 'T_', MODE_KEY = 'dsVehicleMode', SAVED_KEY = 'VehicleSearchSelects';
  var ICON_4WD = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 17h14M3 13l2-5a2 2 0 0 1 2-1h10a2 2 0 0 1 2 1l2 5v4H3z"/><circle cx="7.5" cy="17" r="1.6"/><circle cx="16.5" cy="17" r="1.6"/></svg>';
  var ICON_TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 6h12v11H2z"/><path d="M14 10h4l4 4v3h-8z"/><circle cx="7" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>';
  var POPULAR_4WD = ['Toyota', 'Ford', 'Isuzu', 'Mitsubishi', 'Nissan', 'Mazda'];
  var band, s1, s2, s3, lab, fourMakes, truckMakes, mode, observing, stripping, truckIx;

  function clean(make) { return String(make || '').indexOf(PRE) === 0 ? String(make).slice(PRE.length) : String(make || ''); }
  function isTruckMake(make) { return String(make || '').indexOf(PRE) === 0; }
  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function savedMake() { var r = get(SAVED_KEY); return r ? r.split('|')[0] : ''; }

  function pickMode() {
    var m = savedMake();
    if (m) return isTruckMake(m) ? 'truck' : '4wd';
    var q = /[?&]vehicle=(truck|4wd)\b/i.exec(location.search);
    if (q) { var u = q[1].toLowerCase(); set(MODE_KEY, u); return u; }
    var st = get(MODE_KEY);
    if (st === 'truck' || st === '4wd') return st;
    return /trucksuspensions/i.test(location.hostname) ? 'truck' : '4wd';
  }

  function fire(el) { el.dispatchEvent(new Event('change', { bubbles: true })); }

  function fillMakes(reset) {
    var list = mode === 'truck' ? truckMakes : fourMakes;
    var cur = s1.value;
    s1.innerHTML = '';
    s1.appendChild(new Option('Select Make', 'Select Make'));
    list.forEach(function (m) { s1.appendChild(new Option(clean(m), m)); });
    var keep = !reset && list.indexOf(cur) !== -1;
    s1.value = keep ? cur : 'Select Make';
    if (reset) fire(s1);
  }

  function fillChips() {
    var wrap = band.querySelector('.ds-vband-makes');
    if (!wrap) return;
    var list = mode === 'truck' ? truckMakes.slice(0, 6) : POPULAR_4WD.filter(function (m) { return fourMakes.indexOf(m) !== -1; });
    wrap.innerHTML = '';
    list.forEach(function (m) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = clean(m);
      b.setAttribute('data-make', m);
      if (s1.value === m) b.className = 'is-on';
      b.addEventListener('click', function () { s1.value = m; fire(s1); });
      wrap.appendChild(b);
    });
  }

  /* Plain year keys come out of the file lowest first: show the newest at the top */
  function sortYears() {
    if (mode !== 'truck' || !s3 || s3.options.length < 3) return;
    var opts = [].slice.call(s3.options, 1);
    if (!opts.every(function (o) { return /^\d{4}$/.test(o.value); })) return;
    var sorted = opts.slice().sort(function (a, b) { return Number(b.value) - Number(a.value); });
    if (sorted.every(function (o, i) { return o === opts[i]; })) return;
    var cur = s3.value;
    sorted.forEach(function (o) { s3.appendChild(o); });
    s3.value = cur;
  }
  function fixThird() {
    if (!s3) return;
    var o = s3.options[0];
    if (!o) return;
    if (!o.hasAttribute('value')) o.setAttribute('value', 'Select Sub Model');
    var want = mode === 'truck' ? 'Any variant' : 'Any sub model';
    if (o.textContent !== want) o.textContent = want;
    sortYears();
  }
  function fixThirdLabel() {
    var holder = s3 && s3.closest('.search-by-vehicle-select-holder');
    var em = holder && holder.querySelector('.ds-step em');
    if (em) em.textContent = mode === 'truck' ? 'Variant · optional' : 'Sub model · optional';
    if (s3) s3.setAttribute('aria-label', mode === 'truck' ? 'Vehicle variant' : 'Vehicle sub model');
    fixThird();
  }

  /* Truck model with one option in step 3 (usually "All Years"): nothing to choose, so pick it.
     Picking it is what opens the collection in scripts.js. Runs only when the customer changes the model. */
  function onModel() {
    if (mode !== 'truck' || !s3) return;
    setTimeout(function () {
      if (s3.disabled || s3.options.length !== 2) return;
      s3.value = s3.options[1].value;
      fire(s3);
    }, 0);
  }

  function paintSwitch() {
    [].forEach.call(lab.querySelectorAll('button[data-mode]'), function (b) {
      var on = b.getAttribute('data-mode') === mode;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    band.setAttribute('data-ds-mode', mode);
  }

  function apply(next, reset) {
    mode = next;
    fillMakes(reset);
    fillChips();
    fixThirdLabel();
    paintSwitch();
  }

  function buildSwitch() {
    lab.classList.add('ds-has-switch');
    lab.innerHTML =
      '<span class="ds-vswitch-label" id="DsVswitchLabel">Search by</span>' +
      '<div class="ds-vswitch" role="group" aria-labelledby="DsVswitchLabel">' +
        '<button type="button" data-mode="4wd">' + ICON_4WD + '4WD</button>' +
        '<button type="button" data-mode="truck">' + ICON_TRUCK + 'Truck</button>' +
      '</div>';
    lab.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('button[data-mode]');
      if (!b) return;
      var next = b.getAttribute('data-mode');
      if (next === mode) return;
      set(MODE_KEY, next);
      apply(next, true);
    });
  }

  /* A truck make with a model and no year: same as ds-header.js, but the search words leave out the T_ */
  function onShowParts(e) {
    var btn = e.target.closest && e.target.closest('.search-by-vehicle-btn');
    if (!btn || !band.contains(btn) || !isTruckMake(s1.value)) return;
    if (!s2 || s2.disabled || s2.value === 'Select Model') return;
    if (s3 && !s3.disabled && s3.value !== 'Select Sub Model') return;
    e.preventDefault();
    e.stopPropagation();
    var node = null;
    (window.searchJSON[s1.value] || []).forEach(function (x) { if (x && x[s2.value] != null) node = x[s2.value]; });
    if (typeof node === 'string' && node.indexOf('/collections') === 0) {
      set(SAVED_KEY, s1.value + '|' + s2.value + '||' + node);
      location.href = node;
      return;
    }
    set(SAVED_KEY, s1.value + '|' + s2.value + '||');
    location.href = '/search?q=' + encodeURIComponent(clean(s1.value) + ' ' + s2.value) + '&options%5Bprefix%5D=last&type=product';
  }

  /* The vehicle list panel (head-critical.liquid) groups by make and links each row from searchJSON.
     The list it reads has no T_, so truck rows need their make and link found here. Runs when the panel opens. */
  function vKey(s) { return String(s).toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function truckIndex() {
    if (truckIx) return truckIx;
    truckIx = {};
    truckMakes.forEach(function (mk) {
      (window.searchJSON[mk] || []).forEach(function (row) {
        for (var md in row) {
          var v = row[md];
          if (typeof v === 'string') { truckIx[vKey(clean(mk) + md)] = v; continue; }
          for (var sb in v) truckIx[vKey(clean(mk) + md + sb)] = v[sb];
        }
      });
    });
    return truckIx;
  }
  function fixPanel(pop) {
    var el = pop.dsFor;
    var list = el ? (el.getAttribute('data-ds-more') || '').split('|') : [];
    var old = pop.querySelectorAll('a, .ds-vpop__row');
    if (!list[0] || old.length !== list.length) return;
    var ix = truckIndex();
    var names = Object.keys(window.searchJSON).map(clean).sort(function (a, b) { return b.length - a.length; });
    var frag = document.createDocumentFragment(), lastMk = null;
    list.forEach(function (item, i) {
      var low = item.toLowerCase(), mk = item.split(' ')[0];
      for (var n = 0; n < names.length; n++) {
        if (low.indexOf(names[n].toLowerCase() + ' ') === 0) { mk = item.slice(0, names[n].length); break; }
      }
      if (mk !== lastMk) {
        var head = document.createElement('b');
        head.className = 'ds-vpop__mk';
        head.textContent = mk;
        frag.appendChild(head);
        lastMk = mk;
      }
      var url = old[i].getAttribute('href') || ix[vKey(item)];
      var row = document.createElement(url ? 'a' : 'span');
      if (url) row.setAttribute('href', url); else row.className = 'ds-vpop__row';
      row.textContent = item.slice(mk.length).replace(/^\s+/, '') || item;
      frag.appendChild(row);
    });
    pop.innerHTML = '';
    pop.appendChild(frag);
  }
  function watchPanel() {
    if (!window.MutationObserver) return;
    new MutationObserver(function (l) {
      l.forEach(function (m) {
        [].forEach.call(m.addedNodes, function (a) {
          if (a.classList && a.classList.contains('ds-vpop')) fixPanel(a);
        });
      });
    }).observe(document.body, { childList: true });
  }

  /* A saved truck: take the T_ off wherever the theme prints the make. Does nothing for a 4WD. */
  function sweep(root, raw) {
    if (!root) return;
    if (root.nodeType === 3) {
      if (root.nodeValue.indexOf(raw) !== -1) root.nodeValue = root.nodeValue.split(raw).join(clean(raw));
      return;
    }
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, hits = [];
    while ((n = w.nextNode())) {
      var p = n.parentNode && n.parentNode.nodeName;
      if (p !== 'SCRIPT' && p !== 'STYLE' && n.nodeValue.indexOf(raw) !== -1) hits.push(n);
    }
    hits.forEach(function (t) { t.nodeValue = t.nodeValue.split(raw).join(clean(raw)); });
  }
  function watchSaved() {
    var raw = savedMake();
    if (!isTruckMake(raw) || stripping || !window.MutationObserver) return;
    stripping = true;
    sweep(document.body, raw);
    new MutationObserver(function (list) {
      var now = savedMake();
      if (!isTruckMake(now)) return;
      list.forEach(function (m) {
        if (m.type === 'characterData') sweep(m.target, now);
        else [].forEach.call(m.addedNodes, function (a) { sweep(a, now); });
      });
    }).observe(document.body, { subtree: true, childList: true, characterData: true });
  }

  function init() {
    band = document.getElementById('DsVband');
    var data = window.searchJSON;
    if (!band || !data) return false;
    truckMakes = Object.keys(data).filter(isTruckMake);
    if (!truckMakes.length) return false;
    s1 = band.querySelector('.select-sort-1');
    s2 = band.querySelector('.select-sort-2');
    s3 = band.querySelector('.select-sort-3');
    lab = band.querySelector('.ds-vband-lab');
    if (!s1 || !lab) return false;
    if (!fourMakes) fourMakes = [].map.call(s1.options, function (o) { return o.value; }).filter(function (v) { return v !== 'Select Make' && !isTruckMake(v) && v; });
    if (!observing) {
      observing = true;
      buildSwitch();
      window.addEventListener('click', onShowParts, true);
      if (s2) s2.addEventListener('change', onModel);
      if (s3 && window.MutationObserver) new MutationObserver(fixThird).observe(s3, { childList: true, subtree: true, characterData: true });
      watchPanel();
    }
    apply(pickMode(), false);
    watchSaved();
    /* ds-header.js adds the step labels and chips when it starts: catch up if it starts after this */
    [150, 600, 1600].forEach(function (t) { setTimeout(function () { fillChips(); fixThirdLabel(); }, t); });
    return true;
  }

  window.dsVehicleSwitch = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
